import { FaWhatsapp } from "react-icons/fa";
import { cn } from "@/lib/utils";
import { WHATSAPP_NUMBER, whatsappHref } from "@/lib/whatsapp";

interface WhatsAppCtaProps {
  /** Pre-filled first-person message (English on every locale). */
  message: string;
  /** GA4 "Click location" (event_label), e.g. "ai_agents_hero". Keep it distinct per placement. */
  location: string;
  /** Visible label, already translated by the caller. */
  label: string;
  className?: string;
}

/**
 * Secondary WhatsApp button placed beside a page's primary CTA. Pill styling
 * matches the Claude Partner page's "WhatsApp us about Claude" button.
 * Do not use on /singapore/ pages (the SG number is not final).
 */
export function WhatsAppCta({ message, location, label, className }: WhatsAppCtaProps) {
  return (
    <a
      href={whatsappHref(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-track-event="contact_whatsapp_click"
      data-track-location={location}
      data-track-phone={WHATSAPP_NUMBER}
      className={cn(
        "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary px-7 py-3 text-sm font-semibold text-primary-foreground transition hover:bg-primary-emphasis",
        className,
      )}
    >
      <FaWhatsapp className="h-4 w-4" aria-hidden />
      {label}
    </a>
  );
}
